import React, { useContext, useState } from 'react';
import { DebugContext } from './MindstormPinball';

const DevPanel = () => {
    const debug = useContext(DebugContext);
    const [visible, setVisible] = useState(false);
    const [livesInput, setLivesInput] = useState(debug.lives || 3);

    // Toggle visibility with 'D' key
    React.useEffect(() => {
        const handler = (e) => {
            if (e.key === 'd' || e.key === 'D') {
                setVisible((v) => !v);
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, []);

    if (!visible) return null;

    const resetGame = () => {
        debug.setScore(0);
        debug.setLives(3);
        debug.setFocusLettersLit([false, false, false, false, false]);
        debug.setKickbacks({ left: true, right: true });
        debug.setBalls([]);
        debug.setNextBallId(0);
        setTimeout(() => debug.spawnBall(), 100);
    };

    const drainBall = () => {
        if (debug.balls.length > 0) {
            const id = debug.balls[0].id;
            debug.handleDrain(id);
        }
    };

    const addScore = () => {
        debug.setScore((s) => s + 100000);
    };

    const setLives = () => {
        const val = parseInt(livesInput, 10);
        if (!isNaN(val)) debug.setLives(val);
    };

    const lightFocusNext = () => {
        debug.setFocusLettersLit((prev) => {
            const next = [...prev];
            const idx = prev.findIndex((v) => !v);
            if (idx !== -1) next[idx] = true;
            return next;
        });
    };

    const focusComplete = () => {
        debug.setFocusLettersLit([true, true, true, true, true]);
        debug.setScore((s) => s + 50000);
    };

    const litKickback = () => {
        debug.setKickbacks({ left: true, right: true });
    };

    const tripleMultiball = () => {
        debug.spawnExtraBalls(3);
    };

    const teleportPlunger = () => {
        if (debug.balls.length > 0) {
            const id = debug.balls[0].id;
            debug.setBalls((prev) =>
                prev.map((b) => (b.id === id ? { ...b, position: [8.5, 1.5, 18] } : b))
            );
        }
    };

    return (
        <div
            style={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: 'rgba(0,0,0,0.8)',
                color: '#fff',
                padding: '12px',
                borderRadius: '8px',
                zIndex: 1000,
                maxWidth: '300px',
                fontFamily: 'sans-serif',
            }}
        >
            <h3 style={{ margin: '0 0 8px' }}>Dev Panel</h3>
            {/* Section A */}
            <div>
                <strong>Life & Scoring</strong>
                <button onClick={resetGame}>RESET GAME</button>
                <button onClick={drainBall}>DRAIN BALL</button>
                <div>
                    <input
                        type="number"
                        value={livesInput}
                        onChange={(e) => setLivesInput(e.target.value)}
                        style={{ width: '40px' }}
                    />
                    <button onClick={setLives}>SET LIVES</button>
                </div>
                <button onClick={addScore}>ADD 100K</button>
            </div>
            {/* Section B */}
            <div style={{ marginTop: '8px' }}>
                <strong>Focus Sequence</strong>
                <button onClick={lightFocusNext}>LIGHT FOCUS (Next)</button>
                <button onClick={focusComplete}>FOCUS COMPLETE</button>
            </div>
            {/* Section C */}
            <div style={{ marginTop: '8px' }}>
                <strong>Kickback & Multiball</strong>
                <label>
                    <input type="checkbox" onChange={litKickback} /> LIT KICKBACK
                </label>
                <button onClick={tripleMultiball}>TRIPLE MULTIBALL</button>
                <button onClick={teleportPlunger}>TELEPORT (Plunger)</button>
            </div>
        </div>
    );
};

export default DevPanel;
